import React, { useState } from 'react'
import DirectionIcon from '../../../images/direction.svg'
import LocationIcon from '../../../images/location-distance.svg'
import HospitalIcon from '../../../images/default-book-hospital.svg'
import VaccinceIcon from '../../../images/Book_Vaccine_Slot.svg'
import Paginator from '../on-view'
import ErrorComponent from '../../Error-Component'
import useTranslation from '../../../hooks/use-translation'
import NoCenter from '../../../images/no_center.svg'
import { useAppState } from '../../../contexts/appState'
import ArrowIcon from '../../../images/arrow-ios-downward-fill.svg'
import { useIsMobile } from '../../../hooks/breakpoints'
import useLoader from '../../../hooks/use-loader';
import Loader from '../../Loader';
import { raiseGAEventForVaccination } from '../../../utils/network'
import config from '../../../config.json'

const styles = {

  container: {
    // width: '619px',
    height: 'fit-content',
    fontFamily: 'JioType-Medium',
    border: '0.5px solid #989898',
    borderRadius: '10px',
    display: 'grid',
    flexDirection: 'col',
    marginTop: '1em'
  },
  topcontainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 7fr 2.5fr',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '12px',
    padding: '16px',
  },
  topcontainerMobile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    fontSize: '12px',
    padding: '16px',
  },
  bottomcontainer: {
    display: 'grid',
    gridTemplateColumns: '2.5fr 4.5fr 4.5fr',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '12px',
    // borderTop: '0.5px solid #989898',
    padding: '0px 16px 16px 16px ',
  },
  bottomcontainerMobile: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '12px',
    borderTop: '0.5px solid #989898',
    padding: '12px 16px 16px 16px '
  },
  btnMobile: {
    padding: '0.2rem 0.3rem',
    width: 'max-content',
    color:'#3CB5EA',
    textAlign: 'center',
    marginRight:'-0.5em',
    display:'inline',
    fontSize:'12px',
    borderRadius:'10px',
    border: '0.5px solid #3CB5EA'
  }
}



export default (props) => {
  const { t } = useTranslation()
  const { showLoading, hideLoading } = useLoader();
  const [pageCount, setPageCount] = useState()
  const isMobile = useIsMobile()
  const [{ booking }, dispatch] = useAppState()

  const redirectToCenterDetails = (item) => {
    dispatch({ type: 'SET_CENTER_DETAILS', centerDetails: item })
    // fireGATag(item)
    props.handleNext()
  }

  const redirectToGoogleMaps = (lat, lng) => {
    const url = "http://maps.google.com/maps?daddr=" + lat + "," + lng;
    const win = window.open(url, "_blank");
    win.focus();
  }

  // const fireGATag = (item = {}) => {
  //   raiseGAEventForVaccination({ new_Action: config.gaCenterSelection, new_Label: item.name, new_Category: config.gaBookAppointment, failureReason: 'NA' })
  // }
  const renderDesktop = () => (
    <div style={{ marginBottom: '4em' }}>
      {props.completeCenterList.length >= 1
        ? <Paginator
          hasMore={props.pageLength === 20}
          loader={() => { }}
          loadFunction={props.loadFunction}
        >
          {props.completeCenterList.map((item, index) => {
            return (
              <div style={styles.container} id={index} key={index}>
                <div style={styles.topcontainer}>
                  <div>
                    <img width='40px' height='40px' src={item.centre_image}
                      onError={(e) => { e.target.src = HospitalIcon; e.target.onError = null; }}
                    /></div>
                  <div>
                    <div onClick={() => redirectToCenterDetails(item)} style={{ cursor: 'pointer', color: '#333333', fontSize: '1.35em' }}>{item.name}</div>
                    <div style={{ color: '#989898' }}>{item.address}</div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <div onClick={() => redirectToCenterDetails(item)} style={{ padding: '0.3em 0.5em', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', color: '#3CB5EA', fontSize: '1.2em', border: '1px solid #3CB5EA', borderRadius: '16px', height: '31px', width: '100px' }}>{t('VIEW_DETAILS')}</div>
                </div>
                </div>
                <div style={styles.bottomcontainer}>
                  <div>
                    <img width='20px' height='20px' src={LocationIcon} />
                    <span style={{ marginLeft: '0.5em' }}>{item.distance} {t('KM')}</span>
                  </div>
                  <div style={{ cursor: 'pointer' }} onClick={() => redirectToGoogleMaps(item.lat, item.lng)}>
                    <img width='20px' height='20px' src={DirectionIcon} />
                    <span style={{ color: '#3CB5EA', marginLeft: '0.5em' }}>{t('GET_DIRECTION')}</span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ color: '#FFFFFF', display: 'flex', justifyContent: 'flex-end' }}>
                      <div style={{
                        width: '5.6em', display: 'flex', justifyContent: 'center', alignItems: 'center',
                        textAlign: 'center', backgroundColor: item.color_age_rule, borderRadius: '30px', marginRight: '14px', height: '24px'
                      }}>{item.vaccination_min_age_limit}</div>
                    </div>
                    <div><img width='30px' height='30px' src={VaccinceIcon} /></div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div>{t('FIRST_SECOND')}</div>
                      <div style={{ color: '#989898' }} >{t('DOSE_AVAILABLE')}</div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })
          }
        </Paginator> :
        <ErrorComponent
          image={NoCenter}
          text={t('NO_CENTER')}
          textCss='no-appointments-text'
        />
      }

    </div>
  )


  const renderMobile = () => (
    <div style={{ paddingBottom: '3em' }}>
      {props.completeCenterList?.length >= 1
        ? <Paginator
          hasMore={props.pageLength === 20}
          loader={() => { }}
          loadFunction={props.loadFunction}
        >
          {props.completeCenterList.map((item, index) => {
            return (
              <div style={styles.container} id={index} key={index}>
                <div style={styles.topcontainerMobile}>
                  <div><img width='40px' height='40px' src={item.centre_image}
                    onError={(e) => { e.target.src = HospitalIcon; e.target.onError = null; }} /></div>
                  <div style={{ marginLeft: '0.625rem', width: ' 300%' }}>
                    <div style={{ color: '#333333', fontSize: '14px' }} onClick={() => redirectToCenterDetails(item)}>{item.name}</div>
                    <div style={{ color: '#989898' }}>{item.address}</div>
                    <div style={{ display: 'flex', fontSize: '10px', marginTop: '8px' }}>
                      <div><img width='30px' height='30px' src={VaccinceIcon} /></div>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>{t('FIRST_SECOND')}</div>
                        <div style={{ color: '#989898' }} >{t('DOSE_AVAILABLE')}</div>
                      </div>
                    </div>
                  </div>
                   <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <span onClick={() => redirectToCenterDetails(item)} style={styles.btnMobile}>{t('VIEW_DETAILS')}</span>
                  </div>
                </div>
                <div style={styles.bottomcontainerMobile}>
                  <div>
                    <img width='20px' height='20px' src={LocationIcon} />
                    <span style={{ marginLeft: '0.5em' }}>{item.distance} {t('KM')}</span>
                  </div>
                  <div style={{ paddingLeft: '10px' }} onClick={() => redirectToGoogleMaps(item.lat, item.lng)}>
                    <img width='20px' height='20px' src={DirectionIcon} />
                    <span style={{ color: '#3CB5EA', marginLeft: '0.5em' }}>{t('GET_DIRECTION')}</span>
                  </div>
                  <div style={{ color: '#FFFFFF', display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ width: '5.3em', textAlign: 'center', paddingTop: '0.3em', paddingBottom: '0.3em', backgroundColor: item.color_age_rule, borderRadius: '30px', marginRight: '0.5em' }}>{item.vaccination_min_age_limit}</div>
                  </div>
                </div>
              </div>
            )
          })
          }
        </Paginator>
        :
        <ErrorComponent
          image={NoCenter}
          imageWidth={300}
          text={t('NO_CENTER')}
          textCss='no-appointments-text'
        />
      }
    </div>)

  return (
    <>{props.loading ? <Loader loadingCount={1} /> : isMobile ? renderMobile() : renderDesktop()}</>
  )
}
